<template>
	<div>
		<b-toast
      id="toast-check-modal-cancel-request"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
      >
      <img
        src="@/assets/img/ico-check.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
		</b-toast>
		<b-toast
      id="toast-equis-modal-cancel-request"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
      >
      <img
        src="@/assets/img/ico-equis.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
		</b-toast>
	<b-modal 
		id="modal-cancel-request" 
			:hide-footer="false" 
			:hide-header="false"
			:hide-body="true" 
			:centered="true" 
			:no-close-on-esc="true">
		  <template #modal-header="{ close }">
        <img class="close" src="@/assets/img/close_red.png" @click="close()">
      </template>
        <p class="text-center mb-0" v-if="flagState" >{{$t('modals.cancel-request.text.1')}}</p>	
        <div v-else>
          <p class="text-center mb-0" v-if="type == 1">{{$t('modals.cancel-request.text.1')}}</p>
          <p class="text-center mb-0" v-else>{{flagStateProposal==true?$t('modals.cancel-request.text.2'):$t('modals.cancel-request.text.3')}} {{teacher}}?</p>
			  </div>
      <template #modal-footer>
        <b-button variant="danger" @click="$bvModal.hide('modal-cancel-request')"> {{$t('modals.cancel-request.button-cancel-no')}} </b-button>
        <b-button @click="confirmCancelRequest" variant="primary" :class="{ loading: showSpinnerSave }">
          {{$t('modals.cancel-request.button-confirm-yes')}}
        </b-button>
      </template>
	  </b-modal>
	</div>

</template>
<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import * as Constants from "@/assets/js/appConstants";
export default {
	name:"modalCancelRequest",
	data() {
		return {
			flagState : false,
			showSpinnerSave:false,
			message: ''
		}
	},
	// id : es id generadoi al enviar la solicitud
	props:{
		id:Number,
		teacher: String,
		type : Number,
		groupScheduleProposalId:Number,
		PersonTeacherId :Number,
		tableId : Number,
		flagStateProposal : Boolean
	},
	created() {
		
	},
	methods: {
		confirmCancelRequest(){
			this.showSpinnerSave = true;
			let countList = 0;
			if(this.type == 1){
				let json = {
        			Id: this.id,
				};
				baseInstanceAxios
				.post(`${this.apiURL}/resources/GroupsCoursesLessons/CancelScheduleByStudent`, json)
				.then((response) => {
				
					this.showSpinnerSave = false;
					this.message = this.$t('reusables.successfully-canceled')
          			this.$bvToast.show("toast-check-modal-cancel-request");
					countList =(response.data != null && response.data.entity != null)?response.data.entity.nroGroupScheduleProposal:null;
					this.$emit('showCarouselPrevModel',countList);
					this.$emit('updateSchedule');
					this.$bvModal.hide('modal-cancel-request');
				});
			
			}else{
			
				let json = {
					Id: this.tableId,
					UserMail : this.$store.state.user.email,
					FlagReject : !this.flagState
					//ValueCatalogs:  parseInt(Constants.STATUS.REJECTED)
					//GroupScheduleProposalId: this.groupScheduleProposalId,
					//PersonTeacherId : this.PersonTeacherId,
				};
				console.log("json: ",json)
				baseInstanceAxios
				.post(`${this.apiURL}/resources/GroupScheduleCounterProposal/RejectCounterProposalRequest`, json)
				.then((response) => {
				
					this.showSpinnerSave = false;
					this.message = this.$t('modalCancelRequest.text.2')
          			this.$bvToast.show("toast-check-modal-cancel-request");
					countList =(response.data != null && response.data.entity != null)?response.data.entity.nroGroupScheduleProposal:null;
					this.$emit('showCarouselPrevModel',countList);
					this.$emit('updateSchedule');

					this.$bvModal.hide('modal-cancel-request');
				});
			}
			
		},
		showModal(flagState){
			this.flagState = flagState
			console.log("this.flagState: ",this.flagState)
			this.$bvModal.show("modal-cancel-request")
		}
	}

}
</script>